import React, { useEffect } from 'react';
import HistoryItem from './HistoryItem';
import Loader from '../../utils/Loader';
import EmptyMessage from '../../utils/EmptyMessage';

function PurchaseHistory({
	purchaseHistory,
	getPurchaseHistory,
	loading,
	history,
	download,
	downloading,
	downloadItem,
	invoiceRequested,
	requestInvoice,
}) {
	useEffect(() => {
		getPurchaseHistory();
	}, [getPurchaseHistory]);

	const handleRequest = event => {
		event.preventDefault();
		requestInvoice();
	};

	return (
		<section>
			<div className="WpdSectionTitleWrap">
				<h4 className="WpdSectionTitle mr-2">Purchase History</h4>
			</div>
			{loading ? (
				<Loader />
			) : purchaseHistory && purchaseHistory.length > 0 ? (
				<div className="WpdDataTableWrapper">
					<div
						className={`purchase-invoice-notice ${invoiceRequested === true ? 'is-submitted' : ''}`}
					>
						{invoiceRequested === null && (
							<p>Submitting your request...</p>
						)}

						{invoiceRequested === false && (
							<p>
								<strong>Missing an invoice?</strong>
								<br />
								If your latest invoice isn’t showing here,{' '}
								<button onClick={e => handleRequest(e)}>
									<strong>request it here</strong>
								</button>{' '}
								and we’ll take care of the rest.
							</p>
						)}

						{invoiceRequested === true && (
							<p>
								<strong>Request received successfully.</strong>
								<br />
								Our support team is already looking into your
								missing invoice and will follow up as soon as
								possible.
							</p>
						)}
					</div>
					<table className="WpdDataTable">
						<thead>
							<tr>
								<th>ID</th>
								<th>Date</th>
								<th>Amount</th>
								<th>Status</th>
								<th>Invoice</th>
								<th>License Key</th>
							</tr>
						</thead>
						<tbody>
							{purchaseHistory.map((historyItem, index) => {
								return (
									<HistoryItem
										key={index}
										{...historyItem}
										history={history}
										download={download}
										downloading={downloading}
										downloadItem={downloadItem}
									/>
								);
							})}
						</tbody>
					</table>
				</div>
			) : (
				<EmptyMessage>There have no available Purchase.</EmptyMessage>
			)}
		</section>
	);
}

export default PurchaseHistory;
